// CloudFront distribution E2DMPMH4JDDAWE -> s3://feldman-dev-blogs.
// New per-blog layout: <slug>/index.js (compiled MDX) + <slug>/<assets...>.
// Legacy layout (pre-MDX posts): <slug>.md at the bucket root.
export const BLOG_CDN_BASE = 'https://d31kxobtrqxwq9.cloudfront.net';

/** URL of a blog's compiled MDX module. */
export const compiledBlogUrl = (slug: string): string =>
  `${BLOG_CDN_BASE}/${encodeURIComponent(slug)}/index.js`;

/** URL of a legacy raw-markdown post (back-compat for pre-MDX blogs). */
export const legacyBlogUrl = (slug: string): string =>
  `${BLOG_CDN_BASE}/${encodeURIComponent(slug)}.md`;

/**
 * Resolve an author-relative asset path (e.g. `images/bay.jpg`) against the
 * blog's slug prefix. Absolute URLs and data URIs pass through untouched so
 * authors can still hotlink when they want to. This is what removes the old
 * "hardcode every CloudFront URL by hand" pain.
 *
 * `base` defaults to the CloudFront distribution; the local preview harness
 * (`/preview/:slug`) passes a same-origin base so assets load from `public/`.
 */
export const resolveAsset = (slug: string, src: string, base: string = BLOG_CDN_BASE): string => {
  if (!src) return src;
  if (/^(https?:)?\/\//i.test(src) || src.startsWith('data:')) return src;
  const clean = src.replace(/^\.?\/+/, '');
  return `${base}/${encodeURIComponent(slug)}/${clean}`;
};
